/* Fransk katalog for locale-sales-payments-customers-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inv.unknownAccount': 'Compte inconnu',
  'inv.refund.customerBalance': "Crédit du client",
  'inv.refund.balanceHelp': "Le solde comprend les avoirs, les paiements et les remboursements ci-dessous.",
  'inv.refund.addFee': "Ajouter des frais",
  'inv.refund.businessFee': "Frais payés par l’entreprise",
  'inv.refund.customerReceives': "Le client reçoit",
  'inv.refund.accountDebit': "Débit total du compte",
  'sale.pay.ownerDebt': "Dette à court terme envers les propriétaires",
  'sale.pay.title': 'Paiement',
  'sale.pay.help': 'Choisissez sur quel compte et à quelle date la vente a été payée. Ajoutez des frais ou répartissez le paiement en plusieurs versements. Le total doit correspondre aux lignes de vente.',
  'sale.pay.paidTo': 'Payé sur',
  'sale.pay.choosePaymentAccount': 'Choisir le compte de paiement',
  'sale.create.needPaymentAccount': 'Choisissez « Payé sur » avant d\'enregistrer la vente.',
  'sale.pay.paidDate': 'Date de paiement',
  'sale.pay.fee': 'Frais',
  'sale.pay.addFee': 'Ajouter des frais',
  'sale.pay.removeFee': 'Supprimer les frais',
  'sale.pay.partial': 'Paiements partiels',
  'sale.pay.addPartial': 'Ajouter un paiement partiel',
  'sale.pay.removePartial': 'Supprimer le paiement partiel',
  'sale.pay.seeTransaction': 'Voir la transaction',
  'sale.pay.addAccount': 'Ajouter un compte',
  'sale.pay.addCard': 'Ajouter une carte de crédit',
  'sale.pay.addBankTitle': 'Ajouter un compte bancaire',
  'sale.pay.addCardTitle': 'Ajouter une carte de crédit',
  'sale.pay.addSolutionTitle': 'Ajouter une solution de paiement',
  'sale.pay.solution': 'Solution de paiement',
  'sale.pay.accountType': 'Type de compte',
  'sale.pay.cardOwner': 'La carte appartient à',
  'sale.pay.displayName': 'Nom d\'affichage (facultatif)',
  'sale.pay.orgNumber': 'N° d\'organisation',
  'sale.pay.openingBalance': 'Solde initial pour le rapprochement',
  'sale.pay.openingBalanceDate': 'Date du solde initial',
  'sale.pay.resetChoice': 'Réinitialiser la sélection',
  'sale.cust.helpTitle': 'Client de la vente',
  'sale.cust.help': 'Choisissez ici à qui s\'adresse la vente. Recherchez un client, une liste ou un abonnement enregistré — ou appuyez sur « Nouveau client » pour saisir un destinataire qui n\'est pas encore enregistré. Le nom et l\'adresse sont repris automatiquement sur le document.',
  'sale.cust.optionalHelp': 'Le client est facultatif pour les autres ventes. Activez l\'option si vous voulez lier la vente à un client précis.',
  'sale.cust.search': 'Rechercher des clients, listes et abonnements...',
  'sale.cust.pickExisting': 'Choisir un existant',
  'sale.cust.new': 'Nouveau client',
  'sale.cust.add': 'Ajouter un client',
  'sale.cust.selected': 'Client sélectionné',
  'sale.cust.selectedList': 'Liste de destinataires sélectionnée',
  'sale.cust.none': 'Aucun client sélectionné pour l\'instant',
  'sale.cust.listsAndSubs': 'Listes et abonnements',
  'sale.cust.detailsTitle': 'Détails du client',
  'sale.cust.name': 'Nom du client',
  'sale.cust.namePh': 'Ex. Exemple AS',
  'sale.cust.number': 'N° client',
  'sale.cust.org': 'N° d\'org.',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Adresse',
  'sale.cust.addressPh': 'Rue, code postal et ville',
  'sale.cust.email': 'E-mail',
  'sale.cust.emailPh': 'contact@exemple.fr',
  'sale.cust.phone': 'Téléphone',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Personnes de contact',
  'sale.cust.noContacts': 'Aucune personne de contact ajoutée.',
  'sale.cust.addContact': 'Ajouter une personne de contact',
  'sale.cust.removeContact': 'Supprimer la personne de contact',
  'sale.cust.contactName': 'Nom',
  'sale.cust.contactNamePh': 'Ex. Marie Dupont',
  'sale.cust.contactRole': 'Rôle',
  'sale.cust.contactRolePh': 'Ex. Comptabilité',
  'sale.cust.outstanding': 'Impayé',
  'sale.cust.revenueToDate': 'Chiffre d\'affaires à ce jour',
  'sale.cust.pickPh': 'Client ou numéro',
  'sale.cust.select': 'Choisir un client',
  'sale.cust.use': 'Utiliser le client',
  'sale.cust.noEmail': 'Aucun e-mail pour le client',
  'sale.cust.listDefaultName': 'Liste de clients',
  'sale.cust.updatedToast': 'Client mis à jour dans la vente',
  'sale.cust.noCustomerHelp': 'La vente est enregistrée sans client. Activez l\'interrupteur si vous voulez la lier à un client.',
  'sale.cust.selectHint': 'Choisissez un client, une liste ou un abonnement enregistré - ou utilisez « Nouveau client » pour une saisie libre.',
  'sale.cust.recipientsCount': '{count} destinataires',
  'sale.cust.kindSubscription': 'Abonnement',
  'sale.cust.kindList': 'Liste',
  'sale.cust.noMatches': 'Aucun résultat pour « {query} ».',
  'sale.cust.addAsNew': 'Ajouter « {query} » comme nouveau client',
  'sale.cust.contactDefaultName': 'Personne de contact {n}',
  'sale.cust.saveFailed': 'Impossible d\'enregistrer le client.',
  'sale.pay.accountNameSavings': 'Compte d\'épargne',
  'sale.pay.accountNameOperating': 'Compte courant professionnel',
  'sale.pay.accountNamePrivate': 'Compte privé',
  'sale.pay.accountNameBank': 'Compte bancaire',
  'sale.pay.groupBank': 'Comptes bancaires',
  'sale.pay.groupCard': 'Cartes de crédit',
  'sale.pay.groupPrivate': 'Privé',
  'sale.pay.groupOther': 'Autre',
  'sale.pay.groupGeneric': 'Comptes',
  'sale.pay.cashLabel': 'Espèces',
  'sale.pay.bankNameRequired': 'Donnez un nom au compte bancaire',
  'sale.pay.accountOrCardNameRequired': 'Donnez un nom au compte ou à la carte',
  'sale.pay.accountNumberRequired': 'Saisissez le numéro de compte',
  'sale.pay.bankAccountAdded': 'Compte bancaire ajouté',
  'sale.pay.privateAccountAdded': 'Compte privé ajouté',
  'sale.pay.saveAccountFailed': 'Impossible d\'enregistrer le compte.',
  'sale.pay.accountsUnavailable': 'Les comptes de paiement ne sont pas connectés au backend.',
  'sale.pay.openingSetupRequired': 'Saisissez la date de démarrage et le solde initial. Saisissez 0 si le solde était nul.',
  'sale.pay.invalidLedgerAccount': 'Un numéro de compte valide manque dans le plan comptable.',
  'sale.pay.accountExists': 'Le compte {code} existe déjà.',
  'sale.pay.typePrivateCard': 'Compte privé / carte',
  'sale.pay.newBankAccountNote': 'Un nouveau compte bancaire est créé dans le plan comptable',
  'sale.pay.newPrivateAccountNote': 'Un nouveau compte privé/carte est créé dans le plan comptable',
  'sale.pay.bankAccountSeriesInfo': 'Les comptes bancaires reçoivent le prochain compte libre de la série 192x.',
  'sale.pay.privateAccountSeriesInfo': 'Les cartes/comptes privés reçoivent le prochain compte de liaison libre de la série 206x.',
  'sale.pay.thisGetsAccount': 'Compte attribué',
  'sale.pay.accountNameLabel': 'Nom du compte',
  'sale.pay.accountOrCardNameLabel': 'Nom du compte / de la carte',
  'sale.pay.accountNamePhBank': 'Ex. Compte courant 2',
  'sale.pay.accountNamePhPrivate': 'Ex. Carte du propriétaire Visa',
  'sale.pay.accountNumberLabel': 'Numéro de compte',
  'sale.pay.accountCardRefLabel': 'Compte / numéro de carte / référence (facultatif)',
  'sale.pay.interimAccountPrefix': 'Compte de liaison',
  'sale.pay.cardNameRequired': 'Donnez un nom à la carte de crédit',
  'sale.pay.cardNumberRequired': 'Saisissez le numéro de carte/compte',
  'sale.pay.openingBalanceRequired': 'Saisissez le solde initial et sa date',
  'sale.pay.creditCardDebtPrefix': 'Dette de carte de crédit',
  'sale.pay.cardAdded': 'Carte de crédit ajoutée',
  'sale.pay.saveCardFailed': 'Impossible d\'enregistrer la carte de crédit.',
  'sale.pay.scopeBusiness': 'Entreprise',
  'sale.pay.businessCardNote': 'Les cartes professionnelles sont comptabilisées comme une dette de carte distincte',
  'sale.pay.privateCardNote': 'Les cartes privées sont comptabilisées sur un compte de liaison',
  'sale.pay.businessCardSeriesInfo': 'Les cartes professionnelles qui ne sont pas des comptes bancaires reçoivent le prochain compte libre de la série 238x.',
  'sale.pay.privateCardSeriesInfo': 'Les cartes privées reçoivent le prochain compte de liaison libre de la série 206x.',
  'sale.pay.accountInLedger': 'Compte en comptabilité :',
  'sale.pay.cardNamePhBusiness': 'Ex. Carte entreprise Visa',
  'sale.pay.cardNamePhPrivate': 'Ex. Carte du propriétaire Mastercard',
  'sale.pay.cardNumberLabel': 'Numéro de carte / de compte',
  'sale.pay.cardNumberLabelOptional': 'Numéro de carte / de compte (facultatif)',
  'sale.pay.otherSolution': 'Autre solution de paiement',
  'sale.pay.settlementPrefix': 'Règlement',
  'sale.pay.solutionAdded': 'Solution de paiement ajoutée',
  'sale.pay.saveSolutionFailed': 'Impossible d\'enregistrer la solution de paiement.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe et solutions similaires sont comptabilisés sur un compte de règlement dédié à la solution de paiement, rapproché une fois le règlement versé sur le compte bancaire.',
  'sale.pay.addCardAction': '+ Ajouter une carte de crédit ...',
  'sale.pay.addSolutionAction': '+ Ajouter une solution de paiement ...',
  'sale.pay.partialLabel': 'Paiement partiel {n}',
  'sale.pay.partialStatusRemaining': 'restant',
  'sale.pay.partialStatusTooMuch': 'trop',
  'sale.pay.partialStatusMatches': 'correspond',
  'sale.pay.partialSummary': 'Payé {paid} sur {expected} · {status}',
  'sale.pay.partialMismatch': 'La somme des paiements partiels doit correspondre au total de la vente{feeSuffix} ({expected}).',
  'sale.list.noMembers': 'La liste ne contient aucun client à facturer.',
  'sale.list.customerMissing': 'Le client n\'existe plus.',
  'sale.list.noneCreated': 'Aucune facture n\'a été créée.',
  'sale.list.missingEmailNotice': '{count} factures ont été créées pour des clients sans e-mail et doivent être envoyées ou imprimées manuellement : {names}',
  'sale.list.notCreatedNotice': 'Non finalisé pour : {names}',
  'sale.list.createdNoEmail': 'La facture a été créée, mais le client n\'a pas d\'e-mail. Envoyez-la ou imprimez-la manuellement.',
  'sale.list.noneSent': 'Les factures ont été créées, mais aucune n\'a été envoyée par e-mail. Envoyez-les ou imprimez-les manuellement : {names}',
  'sale.list.recipientsCount': '{count} destinataires',
  'sale.list.sentPartly': 'Envoyé à {sent} destinataires. Non envoyé : {names}',
  'sale.list.sentAll': 'Envoyé à {sent} destinataires.',
  'sale.pay.partialMismatchFeeSuffix': ' moins les frais',
  'sale.pay.feeTooHigh': 'Les frais ne peuvent pas dépasser le montant de la vente ({gross}).',
  'sale.pay.splitMismatchError': 'Les paiements partiels ({paid}) doivent correspondre au total de la vente moins les frais ({expected}).',
  'sale.product.backendUnavailable': 'L\'enregistrement des produits n\'est pas connecté au backend.',
  'sale.product.added': 'Produit « {name} » ajouté',
  'sale.product.updated': 'Produit « {name} » mis à jour',
  'sale.product.saveFailed': 'Impossible d\'enregistrer le produit.',
  'sale.create.backendUnavailable': 'La nouvelle vente n\'est pas connectée au backend.',
});
